import React from 'react';

import { formatDate } from '../../utils/functions';
import BoxConteudo from '../BoxConteudo';
import CustomCol from '../CustomCol';
import CustomRow from '../CustomRow';
import LogInput from './LogInput';

interface LogRegistroProps {
  id?: number;
  dataRegistro?: string;
  usuarioRegistro?: string;
  dataAtualizacao?: string;
  usuarioAtualizacao?: string;
  nEdicoes?: number;
}

const LogRegistro: React.FC<LogRegistroProps> = ({
  id,
  dataRegistro,
  usuarioRegistro,
  dataAtualizacao,
  usuarioAtualizacao,
  nEdicoes,
}) => {
  return (
    <BoxConteudo
      boxTitulo="Identificação do Registro"
      style={{ marginBottom: 15 }}
    >
      <CustomRow>
        <CustomCol width="8%">
          <LogInput name="id" value={id?.toString()} label="ID" />
        </CustomCol>
        <CustomCol width="18%">
          <LogInput
            name="dataRegistro"
            value={dataRegistro ? formatDate(dataRegistro) : ''}
            label="Data do Registro"
          />
        </CustomCol>
        <CustomCol width="24%">
          <LogInput
            name="usuarioRegistro"
            value={usuarioRegistro}
            label="Responsável pelo Registro"
          />
        </CustomCol>
        <CustomCol width="18%">
          <LogInput
            name="dataAtualizacao"
            value={dataAtualizacao ? formatDate(dataAtualizacao) : ''}
            label="Última Atualização"
          />
        </CustomCol>
        <CustomCol width="24%">
          <LogInput
            name="usuarioAtualizacao"
            value={usuarioAtualizacao}
            label="Responsável Últ. Atualização"
          />
        </CustomCol>
        <CustomCol width="8%">
          <LogInput
            name="nEdicoes"
            value={nEdicoes?.toString()}
            label="Edições"
          />
        </CustomCol>
      </CustomRow>
    </BoxConteudo>
  );
};

export default LogRegistro;
